import React from "react";
import { FluidSection, PageContext, WuiltContext } from "@/shared/types";
import { FluidSectionViewer } from "@/FluidPreview/FluidSectionViewer";
import { SectionSkeleton } from "@/shared/Components/SectionSkeleton";

export interface FluidViewerProps {
  data: FluidSection;
  sectionId: string;
  pageContext: PageContext;
  wuiltContext: WuiltContext;
}

export const FluidViewer: React.FC<FluidViewerProps> = ({
  data,
  sectionId,
  pageContext,
  wuiltContext,
}) => {
  // Add state to track if component is mounted on client
  // this is because fluid elements depends on the grid container width
  // and we need to wait for the component to be mounted on client
  const [isMounted, setIsMounted] = React.useState(false);

  // Separate useEffect for client-side mounting detection
  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <SectionSkeleton />;
  }
  return (
    <FluidSectionViewer
      sectionData={data}
      sectionId={sectionId}
      pageContext={pageContext}
      wuiltContext={wuiltContext}
    />
  );
};
